import {ReactNode, useMemo} from 'react';

import {CrmToFrontCustomFieldMapping} from '../../../../../../../../../src/components/accounts/crm/common/crmSyncHelpers';
import {CrmFieldModel} from '../../../../../../../../../src/models/api/crmFieldModel';
import {CrmSyncSourcesEnum} from '../../../../../../../../../src/models/api/crmSyncModel';
import {IconName} from '../../../../../../../../shared/ui/src/components/icon/icon';
import {CrmSyncOptionsEnum, SelectedOption} from '../crmSyncsOptions/crmSyncsOptions';
import {microsoftDynamicsConfig} from './microsoftDynamicsPageConfig';
import {salesforceConfig} from './salesforcePageConfig';

export const enabledSources = [CrmSyncSourcesEnum.MICROSOFT_DYNAMICS, CrmSyncSourcesEnum.SALESFORCE];

export interface CrmSyncsPageConfig {
  logo: string;
  logoSm: string;
  logoTiny: string;
  helpCenterLink: string;
  displayName: string;
  account?: CrmSyncsPageResourceConfig;
  card?: CrmSyncsPageResourceConfig;
}

export interface CrmSyncsPageResourceConfig {
  maxNumberToSync: number;
  syncOptionsTitle: ReactNode;
  syncOptions: CrmSyncsResourceOptions;
  buildExternalUrl: (baseUrl: string, id: string) => string;
  syncMapping: {
    computeRequiredMapping: (selectedOption?: SelectedOption) => ReadonlyArray<CrmToFrontCustomFieldMapping>;
    computeOptionalMapping: (selectedOption?: SelectedOption) => ReadonlyArray<CrmToFrontCustomFieldMapping>;
    computeCrmDefaultFieldIcon: (crmField?: CrmFieldModel) => IconName | undefined;
    computeCrmDefaultFieldPlaceholderIcon: (crmFieldId: string) => IconName | undefined;
    computeCrmDefaultFieldPlaceholderName: (crmFieldId: string) => string | undefined;
    computeFrontDefaultFieldIcon: (frontFieldId?: number) => IconName | undefined;
    computeFrontDefaultFieldName: (frontFieldId?: number) => ReactNode | undefined;
    renderSpecialFieldMessage: (frontFieldId?: number) => ReactNode | undefined;
    filterCrmFields: (crmFields?: ReadonlyArray<CrmFieldModel>) => ReadonlyArray<CrmFieldModel> | undefined;
    defaultCrmFieldType: string;
    description: ReactNode;
  };
}

export type CrmSyncsResourceOptions = {
  [key in CrmSyncOptionsEnum]?: {
    optionText: ReactNode;
    tooltip?: ReactNode;
    dropdownPlaceholder?: ReactNode;
    dropdownTitle?: ReactNode;
    learnMoreLink?: string;
    maxCountError?: ReactNode;
  };
};

function getCrmPageConfig(source: CrmSyncSourcesEnum): CrmSyncsPageConfig {
  switch (source) {
    case CrmSyncSourcesEnum.MICROSOFT_DYNAMICS:
      return microsoftDynamicsConfig;
    case CrmSyncSourcesEnum.SALESFORCE:
    default:
      return salesforceConfig;
  }
}

export function useCrmPageConfig(source: CrmSyncSourcesEnum) {
  return useMemo(() => getCrmPageConfig(source), [source]);
}
